// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleDateline_root__1tgeR","link":"ArticleDateline_link__3HymY","ideasRoot":"ArticleDateline_ideasRoot__X748G"};